import { useCallback } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';
import { translate } from '@/i18n/translate';
import type { Dictionary } from '@/i18n/types';

// Takes the dictionary object directly (not a registry key) so each page only ever imports
// its own namespace file — no shared index to merge, so parallel edits across pages never
// touch the same file.
export function useTranslation<D extends Dictionary>(dict: D) {
  const { language, setLanguage } = useLanguage();

  const t = useCallback(
    (key: keyof D['ro'] & string, vars?: Record<string, string | number>): string =>
      translate(dict, language, key, vars),
    [dict, language],
  );

  return { t, language, setLanguage };
}
